import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import {
  NotificationDTO,
  NotificationResults,
} from 'src/app/models/notifications';
import { PlanogramStatusType } from 'src/app/models/planogram-status';
import { FolderApiService } from 'src/app/services/folder-api.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { PlanogramService } from 'src/app/services/planogram.service';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrl: './notifications.component.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [
        NgbDropdown,
        NgbDropdownToggle,
        NgIf,
        NgbDropdownMenu,
        NgFor,
        NgbDropdownButtonItem,
        NgbDropdownItem,
        DatePipe,
    ],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notificationsResults: NotificationResults | null = null;
  loading = true;
  private refreshInterval: any;

  constructor(
    private notificationsService: NotificationsService,
    private folderApi: FolderApiService,
    private planogramApiService: PlanogramApiService,
    private planogramService: PlanogramService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadNotifications();

    // refresh notifications every 60 seconds
    this.refreshInterval = setInterval(() => {
      this.loadNotifications();
    }, 60000);
  }

  ngOnDestroy(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  loadNotifications() {
    this.loading = true;
    this.notificationsService.getNotifications().subscribe((res) => {
      this.notificationsResults = res;
      this.loading = false;
    });
  }

  get hasUnseenNotifications() {
    if (!this.notificationsResults) return false;
    return this.notificationsResults.notifications.some((n) => !n.isSeen);
  }

  get unseenNotifications() {
    if (!this.notificationsResults) return [];
    return this.notificationsResults.notifications.filter((n) => !n.isSeen);
  }

  async notificationClicked(id: string) {
    this.notificationsService.markAsSeen(id).subscribe(async (success) => {
      if (success && this.notificationsResults) {
        const item = this.notificationsResults.notifications.find(
          (n) => n.id === id
        );
        if (item) {
          item.isSeen = true;
          this.cdr.detectChanges();
        }

        try {
          const planogram = await this.folderApi
            .getNotificationPlanogram(id)
            .toPromise();
          if (planogram) {
            const latestState = [...planogram.states].sort((a, b) => 
              new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
            )[0];
            this.router.navigate([`/planogram/${planogram.guid}/${latestState.guid}`]);
          }
        } catch (err) {
          console.error('Failed to open linked planogram', err);
        }
      }
    });
  }

  goToNotificationsPage() {
    this.router.navigate(['/notifications']);
  }
}
